module.exports = __webpack_public_path__ + "static/img/146.de4a6430.gif";